import { createSlice } from "@reduxjs/toolkit";
import {
  changeLastWorkingDay,
  downloadBulkSeperationTemplate,
  getAllSeperationReportees,
  getNoticePeriod,
  getSeperatonRequestList,
  revokeSeperation,
  submitExitInterview,
  submitSeperation,
  summaryView,
  uploadFileWithPresignedUrl,
} from "./thunk";

const initialState = {
  allReportees: null,
  allReporteesStatus: null,
  seperationRequestList: null,
  seperationRequestListStatus: null,
  submitSeperationResponse: null,
  submitSeperationResponseStatus: null,
  revokeSeperationResponse: null,
  revokeSeperationResponseStatus: null,
  summaryViewResponse: null,
  summaryViewResponseStatus: null,
  fileUploadResponse: null,
  fileUploadResponseStatus: null,
  downloadBulkSeperationResponse: null,
  downloadBulkSeperationResponseStatus: null,
  exitInterviewSubmitResponse: null,
  exitInterviewSubmitResponseStatus: null,
  employeeSelected: null,
  bulkEmployeeList: [],
  isReporteeSeperation: false,
  exitEmployeeDetails: null,
  noticePeriodResponse: null,
  noticePeriodResponseStatus: null,
  changeLwdResponse: null,
  changeLwdResponseStatus: null,
};

const seperationSlice = createSlice({
  name: "seperation",
  initialState: initialState,
  reducers: {
    setInitialState: (state) => {
      const updatedStates = { ...initialState };
      updatedStates.bulkEmployeeList = state.bulkEmployeeList;
      updatedStates.exitEmployeeDetails = state.exitEmployeeDetails;
      return updatedStates;
    },
    setEmployeeSelected: (state, action) => {
      state.employeeSelected = action.payload;
    },
    resetEmployee: (state, action) => {
      state.employeeSelected = null;
    },
    setBulkEmployeeList: (state, action) => {
      state.bulkEmployeeList = action.payload;
    },
    resetBulkEmployeeList: (state, action) => {
      state.bulkEmployeeList = [];
    },
    setIsReporteeSeperation: (state, action) => {
      state.isReporteeSeperation = action.payload;
    },
    clearAllreportees: (state, action) => {
      state.allReportees = null;
      state.allReporteesStatus = null;
    },
    setExitEmployeeDetails: (state, action) => {
      state.exitEmployeeDetails = action.payload;
      state.exitInterviewSubmitResponse = null;
      state.exitInterviewSubmitResponseStatus = null;
    },
    resetNoticePeriodDetails: (state) => {
      state.noticePeriodResponse = null;
      state.noticePeriodResponseStatus = null;
    },
    resetSubmitSeperationResponse: (state) => {
      state.submitSeperationResponse = null;
      state.submitSeperationResponseStatus = null;
    },
    resetDownloadBulkSeperationResponse: (state) => {
      state.downloadBulkSeperationResponse = null;
      state.downloadBulkSeperationResponseStatus = null;
    },
    resetChangeLwdResponse: (state) => {
      state.changeLwdResponse = null;
      state.changeLwdResponseStatus = null;
      state.fileUploadResponse = null;
      state.fileUploadResponseStatus = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(changeLastWorkingDay.pending, (state) => {
      state.changeLwdResponse = null;
      state.changeLwdResponseStatus = "PENDING";
    });
    builder.addCase(changeLastWorkingDay.rejected, (state, action) => {
      state.changeLwdResponse = action.payload;
      state.changeLwdResponseStatus = "ERROR";
    });
    builder.addCase(changeLastWorkingDay.fulfilled, (state, action) => {
      state.changeLwdResponse = action.payload;
      state.changeLwdResponseStatus = "SUCCESS";
    });

    builder.addCase(getAllSeperationReportees.pending, (state, action) => {
      state.allReportees = null;
      state.allReporteesStatus = "PENDING";
    });
    builder.addCase(getAllSeperationReportees.rejected, (state, action) => {
      state.allReportees = action.payload;
      state.allReporteesStatus = "ERROR";
    });
    builder.addCase(getAllSeperationReportees.fulfilled, (state, action) => {
      state.allReportees = action.payload;
      state.allReporteesStatus = "SUCCESS";
    });

    builder.addCase(getSeperatonRequestList.pending, (state, action) => {
      state.seperationRequestList = null;
      state.seperationRequestListStatus = "PENDING";
    });
    builder.addCase(getSeperatonRequestList.rejected, (state, action) => {
      state.seperationRequestList = action.payload;
      state.seperationRequestListStatus = "ERROR";
    });
    builder.addCase(getSeperatonRequestList.fulfilled, (state, action) => {
      state.seperationRequestList = action.payload;
      state.seperationRequestListStatus = "SUCCESS";
    });

    builder.addCase(submitSeperation.pending, (state, action) => {
      state.submitSeperationResponse = null;
      state.submitSeperationResponseStatus = "PENDING";
    });
    builder.addCase(submitSeperation.rejected, (state, action) => {
      state.submitSeperationResponse = action.payload;
      state.submitSeperationResponseStatus = "ERROR";
    });
    builder.addCase(submitSeperation.fulfilled, (state, action) => {
      state.submitSeperationResponse = action.payload;
      state.submitSeperationResponseStatus = "SUCCESS";
    });

    builder.addCase(revokeSeperation.pending, (state, action) => {
      state.revokeSeperationResponse = null;
      state.revokeSeperationResponseStatus = "PENDING";
    });
    builder.addCase(revokeSeperation.rejected, (state, action) => {
      state.revokeSeperationResponse = action.payload;
      state.revokeSeperationResponseStatus = "ERROR";
    });
    builder.addCase(revokeSeperation.fulfilled, (state, action) => {
      state.revokeSeperationResponse = action.payload;
      state.revokeSeperationResponseStatus = "SUCCESS";
    });

    builder.addCase(summaryView.pending, (state, action) => {
      state.summaryViewResponse = null;
      state.summaryViewResponseStatus = "PENDING";
    });
    builder.addCase(summaryView.rejected, (state, action) => {
      state.summaryViewResponse = action.payload;
      state.summaryViewResponseStatus = "ERROR";
    });
    builder.addCase(summaryView.fulfilled, (state, action) => {
      state.summaryViewResponse = action.payload;
      state.summaryViewResponseStatus = "SUCCESS";
    });

    builder.addCase(uploadFileWithPresignedUrl.pending, (state, action) => {
      state.fileUploadResponse = null;
      state.fileUploadResponseStatus = "PENDING";
    });
    builder.addCase(uploadFileWithPresignedUrl.rejected, (state, action) => {
      state.fileUploadResponse = action.payload;
      state.fileUploadResponseStatus = "ERROR";
    });
    builder.addCase(uploadFileWithPresignedUrl.fulfilled, (state, action) => {
      state.fileUploadResponse = action.payload;
      state.fileUploadResponseStatus = "SUCCESS";
    });

    builder.addCase(downloadBulkSeperationTemplate.pending, (state, action) => {
      state.downloadBulkSeperationResponse = null;
      state.downloadBulkSeperationResponseStatus = "PENDING";
    });
    builder.addCase(
      downloadBulkSeperationTemplate.rejected,
      (state, action) => {
        state.downloadBulkSeperationResponse = action.payload;
        state.downloadBulkSeperationResponseStatus = "ERROR";
      }
    );
    builder.addCase(
      downloadBulkSeperationTemplate.fulfilled,
      (state, action) => {
        state.downloadBulkSeperationResponse = action.payload;
        state.downloadBulkSeperationResponseStatus = "SUCCESS";
      }
    );

    builder.addCase(submitExitInterview.pending, (state, action) => {
      state.exitInterviewSubmitResponse = null;
      state.exitInterviewSubmitResponseStatus = "PENDING";
    });
    builder.addCase(submitExitInterview.rejected, (state, action) => {
      state.exitInterviewSubmitResponse = action.payload;
      state.exitInterviewSubmitResponseStatus = "ERROR";
    });
    builder.addCase(submitExitInterview.fulfilled, (state, action) => {
      state.exitInterviewSubmitResponse = action.payload;
      state.exitInterviewSubmitResponseStatus = "SUCCESS";
    });

    builder.addCase(getNoticePeriod.pending, (state, action) => {
      state.noticePeriodResponse = null;
      state.noticePeriodResponseStatus = "PENDING";
    });
    builder.addCase(getNoticePeriod.rejected, (state, action) => {
      state.noticePeriodResponse = action.payload;
      state.noticePeriodResponseStatus = "ERROR";
    });
    builder.addCase(getNoticePeriod.fulfilled, (state, action) => {
      state.noticePeriodResponse = action.payload;
      state.noticePeriodResponseStatus = "SUCCESS";
    });
  },
});

export const seperationActions = seperationSlice.actions;

export default seperationSlice.reducer;
